export default "__VITE_ASSET__vVd5xm8a__"